/** Default dwell between middle stop arrival and departure (minutes). */
export const SHIPMENT_COMPOSER_DEFAULT_DWELL_MINUTES = 15

export const SHIPMENT_COMPOSER_MAX_DRIVING_HOURS_DEFAULT = 11

export const SHIPMENT_COMPOSER_REST_HOURS_DEFAULT = 8

/** When both manual origin departure and destination arrival disagree with the forward chain by at least this delta, show the conflict dialog. */
export const SHIPMENT_COMPOSER_ANCHOR_CONFLICT_THRESHOLD_MS = 24 * 60 * 60 * 1000

export const SHIPMENT_COMPOSER_DWELL_MIN_MINUTES = 1
export const SHIPMENT_COMPOSER_DWELL_MAX_MINUTES = 240

export const SHIPMENT_COMPOSER_MAX_DRIVING_HOURS_MIN = 1
export const SHIPMENT_COMPOSER_MAX_DRIVING_HOURS_MAX = 24

export const SHIPMENT_COMPOSER_REST_HOURS_MIN = 1
export const SHIPMENT_COMPOSER_REST_HOURS_MAX = 24
